import { min } from 'd3-array';

export function renderRangeBarSeries(parentElem, graph, panel, series, xScale, yScale) {

	const xData = graph.config.data
		.map(graph.config.xAxis.config.dataAccessor)
		.sort((a, b) => a - b);

	const xDistances = xData
		.slice(1)
		.map((value, index) => Math.abs(xScale(value) - xScale(xData[index])))
		.filter(value => value > 0);

	const barWidth = xDistances.length > 0
		? min(xDistances)
		: Math.abs(xScale.range()[1] - xScale.range()[0]);

	parentElem.append('g')
		.attr('class', `hw_panel_graph_series hw_panel_graph_range_bar_series hw_panel_graph_series_${series.config.name}`)
		.selectAll(`rect.${series.config.name}`)
		.data(graph.config.data.filter(d => series.config.dataAccessor(d) !== null))
		.enter()
		.append('rect')
		.attr('x', d => xScale(graph.config.xAxis.config.dataAccessor(d)) - barWidth / 2)
		.attr('y', d => {
			const value = series.config.dataAccessor(d);
			return Math.min(yScale(value[0]), yScale(value[1]));
		})
		.attr('width', barWidth + 0.5)
		.attr('height', d => {
			const value = series.config.dataAccessor(d);
			return Math.abs(yScale(value[0]) - yScale(value[1]));
		});

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-series-range-bar.js